import Axios from "axios";
import React, { useState } from "react";

const NewsletterForm = () => {
    const [email, setEmail] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(false);
    const [visitorIP, setVisitorIP] = useState("00.00.00.000");
    const [registered, setRegistered] = useState('');

    const handleEmailChange = (event) => {
        const newEmail = event.target.value;
        setEmail(newEmail);
        setIsValidEmail(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail));
    };

    const getVisitorIP = () => {
        // Fetch the Visitor IP address from the API
        fetch("https://api.ipify.org?format=json")
            .then(response => response.json())
            .then(data => setVisitorIP(data.ip))
            .catch(error => {
                console.error("Error fetching IP address:", error);
                setVisitorIP("00.00.00.000");
            });
    };

    // I run api to collect the VisitorIP
    getVisitorIP();

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission behavior

        try {
            const data = {
                email: email,
                visitorIP: visitorIP,
            };

            //console.log("Submitting data:", data); // Log the data being submitted

            //await Axios.post('http://localhost/richard_xampp/aprenderia-server/api/post_newsletter.php', data);
            await Axios.post('https://www.aprender.ai/aprenderia-server/api/post_newsletter.php', data);
            

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error("Server error:", error.response.data);
                console.error("Status code:", error.response.status);
                console.error("Headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error("No response received:", error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error("Error setting up request:", error.message);
            }
            console.error("AxiosError:", error.config);
        } 
        setRegistered('El Email ha sido registrado a la newsletter');
    };

    return (
        <React.Fragment>
           
        <div className="w3-card-4 w3-margin w3-black w3-opacity w3-hover-opacity-off w3-quarter livecard">
            <form onSubmit={handleSubmit}>
                <div className="w3-panel w3-black w3-opacity w3-card w3-hover-opacity-off w3-padding-32" style={{ paddingLeft: '32px', paddingRight: '32px', marginTop: '0', minHeight: '100%' }}>
                    <h2>Recibe Notificaciones de nuevos Cursos y Material Gratuitos.</h2>
                    <p className="w3-xlarge">Inscríbete a la Newsletter.</p>
                    <label className="w3-xlarge" htmlFor="emailInput">E-mail</label>
                    <input
                        id="emailInput"
                        className="w3-input w3-border"
                        type="text"
                        placeholder="Escribe tu e-mail"
                        value={email}
                        onChange={handleEmailChange}
                        required
                    />
                    {isValidEmail ? (
                        <button type="submit" className="w3-button w3-red w3-margin-top w3-xlarge" disabled={!isValidEmail}>
                            Subscríbete
                        </button>
                    ) : (
                        <button type="submit" className="w3-button w3-red w3-margin-top w3-xlarge" disabled={true}>
                            Subscríbete
                        </button>
                    )}
                    <div className="w3-black w3-padding-64 w3-center">{registered}</div>
                </div>
            </form>
            <div className="w3-container w3-center w3-padding-32"><img src="logo-gif-1.gif" alt="Aprender IA Logo" width="150"/></div>
        </div>
    </React.Fragment>
    );
};

export default NewsletterForm;